import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=5cc55bb6&scoped=true"
import script from "./propaganda.vue?vue&type=script&lang=js"
export * from "./propaganda.vue?vue&type=script&lang=js"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=5cc55bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc55bb6",
  null
  
)

export default component.exports